import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'ambassador-start',
		path: '/ambassadors/:token/start',
		component: loadable(async () => import(/* webpackChunkName: "pages/ambassadors-start" */ './index'), {
			exportName: 'AmbassadorStart',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: false,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
